import { render } from "./CommercialMetrics.vue?vue&type=template&id=40c099c0&scoped=true"
import script from "./CommercialMetrics.vue?vue&type=script&lang=js"
export * from "./CommercialMetrics.vue?vue&type=script&lang=js"

import "./CommercialMetrics.vue?vue&type=style&index=0&id=40c099c0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40c099c0"]])

export default __exports__